<div fxLayout="row" fxLayoutAlign="start center" class="u-height-100">
  <div [ngStyle]="{ 'word-break': 'break-all' }">
    <ng-container i18n="@@settingsView.description">{description, select,
      undefined {}
      other {{{ description }}}
    }</ng-container>
  </div>
</div>
